import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_self_devliery_send} from "../../../../../function/FnBodyDelivery";

@observer
class DeliveryCallViewSelf extends Component {
    constructor(props) {
        super(props);
        const { rootStore } = this.props;
        const deliveryAspList = rootStore.deliveryStore.getDeliveryAsp;
        this.selfDeliveryList = [];
        deliveryAspList.map(list=>{
            if(list.retire_fg === "0") {
                this.selfDeliveryList = [...this.selfDeliveryList, list]
            }
        })
        this.state = {startNo:0}
        rootStore.deliveryStore.setSelfDelivery((this.selfDeliveryList.length > 0)?this.selfDeliveryList[0]:null)
    }

    prev=()=>{
        const { rootStore } = this.props;
        if( this.state.startNo > 0 ) {
            this.setState({
                startNo: this.state.startNo - 1
            })
            rootStore.deliveryStore.setSelfDelivery(this.selfDeliveryList[this.state.startNo - 1])
        }
    }

    next=()=>{
        const { rootStore } = this.props;
        if( this.state.startNo < this.selfDeliveryList.length-3 ) {
            this.setState({
                startNo: this.state.startNo + 1
            })
            rootStore.deliveryStore.setSelfDelivery(this.selfDeliveryList[this.state.startNo + 1])
        }
    }

    setRider=(obj)=>{
        const { rootStore } = this.props;
        rootStore.deliveryStore.setSelfDelivery(obj)
    }

    callSelfDelivery=()=>{
        const { rootStore } = this.props;
        rootStore.orderStore.setcheckDeposit({
            stepCd:'500',payFg:''
        })
        fn_self_devliery_send(rootStore)
    }

    render() {
        const { rootStore } = this.props;
        let viewData = this.selfDeliveryList.slice(this.state.startNo, this.state.startNo+3)
        const raiderInfo = rootStore.deliveryStore.getSelfDelivery;
        const arr=['0','1','2']
        let indexCnt = 0
        return(
            <>
                {
                    (Array.isArray(viewData) && viewData.length > 0) ?
                        <div className="wrap_self">
                            <div className="wrap_rider_list">
                                <div className="inner">
                                    <ul className="list">
                                        {
                                        arr.map((arr) => (
                                            (viewData[arr] != null) ?
                                                <li key={viewData[arr].emp_no+(indexCnt++)}
                                                    className={(raiderInfo.emp_no === viewData[arr].emp_no) ? "on" : null}>
                                                    <button onClick={e => this.setRider(viewData[arr])}>
                                                        <span className="name mutiline">{viewData[arr].emp_nm}</span>
                                                    </button>
                                                </li>
                                                :
                                                <li key={indexCnt++}>
                                                    <div className="none"></div>
                                                </li>
                                        ))
                                        }
                                    </ul>
                                </div>
                                <div className="prev">
                                    <button onClick={this.prev}><span></span></button>
                                </div>
                                <div className="next">
                                    <button onClick={this.next}><span></span></button>
                                </div>
                            </div>
                            <div className="wrap_full_btn" onClick={this.callSelfDelivery}>
                                <button >배달시작</button>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    (this.selfDeliveryList.length == 0)?
                        <div className="wrap_rider_list_null"> {/*hide*/}
                            <h3>등록된 라이더가 없습니다.</h3>
                            <p>[설정] &gt; [자체배달원 관리] 메뉴에서 자체배달원을 설정해주세요</p>
                        </div> : null
                }
            </>
        );
    }
}

export default DeliveryCallViewSelf;